module.exports = __webpack_public_path__ + "img/reefoasis.f5c87a0e.jpg";